import { inject, Injectable, Input, signal } from '@angular/core';
import { CommonHttpService } from '../common-http.service';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ITicketsEventResponse } from '../../models/ITicketsEventResponse';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { IMeals } from '../../models/IMeals';


@Injectable({
  providedIn: 'root'
})
export class TicketService {

  @Input() isHomePage = false;

  private httpService = inject(CommonHttpService)

  ticketEventSignal = signal<ITicketsEventResponse | null>(null);
  mealsSignal = signal<IMeals[]>([]);

  lastAuctionId: number | null = null;

  isLoading = signal(true);


  getAllTickets(endpoint: string, auctionId: number, discountCode?: string): Observable<ITicketsEventResponse> {
    const url = `${environment.apiUrl}/v3/auctions/${auctionId}/${endpoint}`;

    let params = new HttpParams();
    if (discountCode) {
      params = params.set('discountCode', discountCode);
    }


    return this.httpService.get<ITicketsEventResponse>(url, params).pipe(
      tap(response => {
        // console.log(response)
        this.ticketEventSignal.set(response);
        if (response.meals) {
          this.mealsSignal.set(response.meals);
        }
        this.isLoading.set(false);
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg =
          typeof error.error === 'string' ? error.error : 'Unknown Error';
        return throwError(() => new Error(errorMsg));
      })
    );
  }

  getMealsSignal() {
    return this.mealsSignal.asReadonly();
  }


  get ticketsData() {
    return this.ticketEventSignal();
  }


}